import {
    DISABLE_MFA,
    DISABLE_MFA_ERROR,
    DISABLE_MFA_SUCCESS,
    ENABLE_MFA,
    ENABLE_MFA_ERROR,
    ENABLE_MFA_SUCCESS,
    INIT_MFA
} from "./actionTypes";

const initialState = {
    success: false,
    error: null,
    loading: false
};

const mfa = (state = initialState, action) => {
    switch (action.type) {
        case ENABLE_MFA:
            state = {
                ...state,
                success: false,
                error: null,
                loading: true
            };
            break;
        case ENABLE_MFA_SUCCESS:
            state = {
                ...state,
                success: true,
                error: null,
                loading: false
            };
            break;
        case ENABLE_MFA_ERROR:
            state = {
                ...state,
                success: false,
                error: action.payload,
                loading: false
            };
            break;
        case DISABLE_MFA:
            state = {
                ...state,
                success: false,
                error: null,
                loading: true
            };
            break;
        case DISABLE_MFA_SUCCESS:
            state = {
                ...state,
                success: true,
                error: null,
                loading: false
            };
            break;
        case DISABLE_MFA_ERROR:
            state = {
                ...state,
                success: false,
                error: action.payload,
                loading: false
            };
            break;
        case INIT_MFA:
            state = initialState;
            break;
        default:
            state = {...state};
            break;
    }
    return state;
};

export default mfa;